import { NgModule } from '@angular/core';
import { provideLazyLoad } from '@core/jss-utils';

import { SolarPanelsWizardContainerComponent } from './solar-panels-wizard-container/solar-panels-wizard-container.component';
import { SolarPanelsResultOverviewContainerComponent } from './solar-panels-result-overview-container/solar-panels-result-overview-container.component';
import { SolarPanelsResultOverviewSummaryContainerComponent } from './solar-panels-result-overview-summary-container/solar-panels-result-overview-summary-container.component';

@NgModule({
  imports: [
    provideLazyLoad({
      SolarPanelsWizard: SolarPanelsWizardContainerComponent,
      SolarPanelsResultOverview: SolarPanelsResultOverviewContainerComponent,
      SolarPanelsResultOverviewSummary:
        SolarPanelsResultOverviewSummaryContainerComponent,
    }),
  ],
})
export class FehSolarPanelsLazyModule {}
